import SiteHeader from "./components/SiteHeader";
import NewsTicker from "./components/NewsTicker";
import HeroEditorial from "./components/HeroEditorial";
import FlashNews from "./components/FlashNews";
import TopicWall from "./components/TopicWall";
import ExclusiveGrid from "./components/ExclusiveGrid";
import ChannelGuide from "./components/ChannelGuide";
import TrustBar from "./components/TrustBar";
import FaqSection from "./components/FaqSection";
import SubscribeCta from "./components/SubscribeCta";
import SiteFooter from "./components/SiteFooter";
import ToastHost from "@/hooks/useToast";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <NewsTicker />
      <main className="flex-1">
        <HeroEditorial />
        <FlashNews />
        <TopicWall />
        <ExclusiveGrid />
        <ChannelGuide />
        <TrustBar />
        <FaqSection />
        <SubscribeCta />
      </main>
      <SiteFooter />
      <ToastHost />
    </div>
  );
}